<template>
    <span v-html="newLineToBr(getText.content)"></span>
</template>

<script>
export default {
    name: "get-text",
    props: {
        name: String
    } ,
    computed: {
        getText: function () {
            let texts = this.$store.getters.texts;
            let result = texts.filter(item => {
                return item.name == this.name
            })
            return result[0];
        }
    },
    methods: {
        newLineToBr(text) {
            return text.replace(/(?:\r\n|\r|\n)/g, '<br>')
        }
    }
}
</script>
